module.exports = __webpack_public_path__ + "img/Weilin Event Center Software.a64b937f.jpg";